<template>
    <swb-query-sort-area :config="queryConfig" :queryHandler="doQueryHandler"></swb-query-sort-area>
</template>

<script>
    import { Utils} from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigFstData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "系统合同编号",
            "code": "no",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "合同名称",
            "code": "title",
            "basic": true
        }/*, {
            "type": "Text",
            "valueType": "String",
            "label": "自用合同编号",
            "code": "fstPartyHtBh",
            "basic": true
        }*/, {
            "type": "Text",
            "valueType": "String",
            "label": "合同编号",
            "code": "accordHtBh",
            "basic": true
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "签署日期",
            "code": "signDate",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "自用合同标签",
            "code": "fstPartyFlag",
            "basic": true
        }, {
            "type": "Select",
            "label": "合同种类",
            "code": "kindId",
            "valueType": "Integer",
            "basic": true,
            "dataList": [{"value": null, "label": "- 全部 -"}, {"value": "0", "label": "标准合同"}, {"value": "1", "label": "框架合同"}]
        }, {
            "type": "Select",
            "label": "买家纳税类型",
            "code": "fstTaxPayType",
            "valueType": "Integer",
            "basic": true,
            "dataList": [{"value": null, "label": "- 全部 -"}, {"value": "0", "label": "无"}, {"value": "1", "label": "小规模纳税人"}, {"value": "2", "label": "一般纳税人"}]
        }, {
            "type": "Select",
            "label": "卖家纳税类型",
            "code": "sndTaxPayType",
            "valueType": "Integer",
            "basic": true,
            "dataList": [{"value": null, "label": "- 全部 -"}, {"value": "0", "label": "无"}, {"value": "1", "label": "小规模纳税人"}, {"value": "2", "label": "一般纳税人"}]
        }, {
            "type": "Select",
            "label": "合同到期",
            "code": "dateEndDue",
            "valueType": "Boolean",
            "basic": true,
            "dataList": [{"value": null, "label": "- 全部 -"}, {"value": true, "label": "已到期"}, {"value": false, "label": "未到期"}]
        }, /*{
         "type": "Date2",
         "valueType": "String",
         "label": "创建日期",
         "code": "createTime"
         }, */{
            "type": "Date2",
            "valueType": "String",
            "label": "结束日期",
            "code": "dateEnd"
        }, {
            "type": "Num2",
            "valueType": "Float",
            "label": "预计合同金额",
            "code": "estmtAmount"
        }],
        "sortFields": [{
            "label": "签署日期",
            "code": "signDate",
            "order": "desc",
            "enabled": true
        }, {
            "label": "结束日期",
            "code": "dateEnd",
            "order": "desc",
            "enabled": true
        }]
    };
    let searchConfigSndData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "系统合同编号",
            "code": "no",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "合同名称",
            "code": "title",
            "basic": true
        }/*, {
            "type": "Text",
            "valueType": "String",
            "label": "自用合同编号",
            "code": "sndPartyHtBh",
            "basic": true
        }*/, {
            "type": "Text",
            "valueType": "String",
            "label": "合同编号",
            "code": "accordHtBh",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "自用合同标签",
            "code": "sndPartyFlag",
            "basic": true
        }, {
            "type": "Select",
            "label": "合同种类",
            "code": "kindId",
            "valueType": "Integer",
            "basic": true,
            "dataList": [{"value": null, "label": "- 全部 -"}, {"value": "0", "label": "标准合同"}, {"value": "1", "label": "框架合同"}]
        }, {
            "type": "Select",
            "label": "买家纳税类型",
            "code": "fstTaxPayType",
            "valueType": "Integer",
            "basic": true,
            "dataList": [{"value": null, "label": "- 全部 -"}, {"value": "0", "label": "无"}, {"value": "1", "label": "小规模纳税人"}, {"value": "2", "label": "一般纳税人"}]
        }, {
            "type": "Select",
            "label": "卖家纳税类型",
            "code": "sndTaxPayType",
            "valueType": "Integer",
            "basic": true,
            "dataList": [{"value": null, "label": "- 全部 -"}, {"value": "0", "label": "无"}, {"value": "1", "label": "小规模纳税人"}, {"value": "2", "label": "一般纳税人"}]
        }, {
            "type": "Select",
            "label": "合同到期",
            "code": "dateEndDue",
            "valueType": "Boolean",
            "basic": true,
            "dataList": [{"value": null, "label": "- 全部 -"}, {"value": true, "label": "已到期"}, {"value": false, "label": "未到期"}]
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "签署日期",
            "code": "signDate",
            "basic": true
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "结束日期",
            "code": "dateEnd",
            "basic": true
        }, {
            "type": "Num2",
            "valueType": "Float",
            "label": "预计合同金额",
            "code": "estmtAmount"
        }],
        "sortFields": [{
            "label": "签署日期",
            "code": "signDate",
            "order": "desc",
            "enabled": true
        }, {
            "label": "结束日期",
            "code": "dateEnd",
            "order": "desc",
            "enabled": true
        }]
    };

    export default {
        name: 'swb-contract-search',
        desc: '合同搜索',
        props: {
            contractType: {
                type: Number
            },
            isFstParty: {
                type: Boolean,
                default: true
            },
            tag: {
                type: String,
                default: null
            }
        },
        watch: {
            tag(newVal, oldVal){
                let tagCode = "fstPartyFlag";
                let queryConfig = this.queryConfig;
                if(!this.isFstParty) {
                    tagCode = "sndPartyFlag";
                }
                let queryConfigMap = queryConfig.queryFields.toMap("code");
                let noItem = queryConfigMap[tagCode];
                if(!Utils.isNoB(newVal)) {
                    noItem.forcedValue = newVal;
                } else {
                    noItem.value = null;
                }
                //
                this.queryConfig = Utils.merge({}, queryConfig);
            }
        },
        data: function () {
            return {
                queryConfig: null
            }
        },
        created: function () {
            let contractType = this.contractType;
            let goodsPurch = getEnumInfoWith("contractType", 'name', 'GoodsPurch');
            let servcPurch = getEnumInfoWith("contractType", 'name', 'ServcPurch');
            //----------------------搜索排序----------------------------
            //查询排序配置信息
            let searchConfigData = {};
            if(this.isFstParty) {
                searchConfigData = Utils.merge({}, searchConfigFstData);
            } else {
                searchConfigData = Utils.merge({}, searchConfigSndData);
            }
            let queryConfig = searchConfigData || {};
            //
            let no = this.$route.query.no || null;
            let queryConfigMap = queryConfig.queryFields.toMap("code");
            if(!Utils.isNoB(no)) {
                let noItem = queryConfigMap['no'];
                noItem.value = no;
            }
            //
            this.queryConfig = queryConfig;
        },
        methods: {
            doQueryHandler(queryModel){
                console.log('----------  查询、排序参数 ---------');
                console.log(queryModel);
                this.queryModel = queryModel;
                //
                this.$emit('notity-syncRefresh', queryModel);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/contract/ContractSearch.vue